import React, { useState, useMemo } from "react";
import useToggle from "../../../Hooks/useToggle";
import editbutton from "../../../static/images/edit-button.svg";
import axios from "axios";
import toast from "react-hot-toast";
import useOnceEffect from "../../../Hooks/useOnceEffect";
import Tooltip from "@material-ui/core/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

export default function Insignias({ id }) {
  const role = localStorage.getItem("rol");
  const user = id ?? localStorage.getItem("userId");

  const [insignias, setInsignias] = useState([]);
  const [show, toggleShow] = useToggle(false);
  const [more, toggleMore] = useToggle(false);

  const [add, setAdd] = useState({
    typeMedalId: 1,
    nota: "",
    userReceiverId: parseInt(user),
  });

  const addCode = useMemo(
    () => (
      <button className="edit-btn" onClick={toggleShow}>
        <img src={editbutton} alt="Agregar Experiencia" />
      </button>
    ),
    [toggleShow]
  );

  function RenderInsignias() {
    let _aux = [];

    if (insignias.length > 3) {
      _aux = [insignias[0], insignias[1], insignias[2]];
    } else {
      _aux = insignias;
    }

    return _aux;
  }

  function submit(e) {
    e.preventDefault();

    axios
      .post("medal/create-medal", add)
      .then(({ data }) => {
        toast.success("Medalla agregada");
        setInsignias([...insignias, data]);
      })
      .catch(() => toast.error("Error al agregar medalla"))
      .finally(() => toggleShow());
  }

  function getMedalClass(medalId) {
    switch (parseInt(medalId)) {
      case 1:
        return "alpha";

      case 2:
        return "beta";

      case 3:
        return "gamma";
      default:
        return "";
    }
  }

  function deleteMedal(medal) {
    let { medalId = null } = medal;

    if (medalId === null) {
      toast.error("Insignia no encontrada");
      return;
    }

    axios
      .delete(`medal/delete/${medalId}`)
      .then(({ data }) => {
        toast.success(data.message);

        setInsignias((_old) => {
          return _old.filter((elm) => elm.medalId !== medalId);
        });
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  }

  useOnceEffect(() => {
    let is_mounted = true;

    axios
      .get(`medal/list-medal/${user}`)
      .then((res) => (is_mounted ? setInsignias(res.data) : null));

    return () => {
      is_mounted = false;
    };
  });

  return (
    <>
      <div className="profile__badge">
        {role === "admin" && <>{addCode}</>}

        <div className="row-title">Mis Insignias</div>
        <div className="profile__badges">
          <div className="profile__badge-list">
            {RenderInsignias().map((elm, i) => {
              return (
                <>
                  <Tooltip key={i} title={elm.nota}>
                    <span
                      alt={i}
                      className={
                        getMedalClass(elm?.typeMedalId?.typeMedalId) +
                        " " +
                        (role === "admin" ? "admin-medal" : "")
                      }
                    >
                      {role === "admin" && (
                        <button
                          className="trash-medal"
                          style={{ color: "rgb(225, 29, 72)" }}
                          onClick={() => deleteMedal(elm)}
                        >
                          <i
                            class="fas fa-times"
                            style={{ color: "rgb(225, 255, 255)" }}
                          />
                        </button>
                      )}
                    </span>
                  </Tooltip>
                </>
              );
            })}
          </div>
        </div>
        <div className="profile__badge-footer">
          {insignias.length > 3 && <span onClick={toggleMore}>Ver más</span>}
        </div>
      </div>

      <Modal show={show} onHide={toggleShow} size="lg" className="kr-modal">
        <Modal.Body>
          <h5>Agregar una Insignia</h5>

          <form onSubmit={submit}>
            <div className="form-group my-3">
              <label>Escoja el tipo de insginia</label>
              <select
                value={add.typeMedalId}
                onChange={({ target }) =>
                  setAdd({ ...add, typeMedalId: parseInt(target.value) })
                }
                className="form-control"
                required
              >
                <option value={1}>Alpha</option>
                <option value={2}>Beta</option>
                <option value={3}>Gamma</option>
              </select>
            </div>

            <div className="form-group my-3">
              <label>Nota de la insignia</label>
              <input
                value={add.nota}
                onChange={({ target }) =>
                  setAdd({ ...add, nota: target.value })
                }
                className="form-control"
                required
              />
            </div>

            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-deg1 mr-3">
                Agregar
              </button>
              <button
                type="button"
                className="btn-deg1"
                style={{ backgroundColor: "grey" }}
                onClick={toggleShow}
              >
                Cancelar
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={more} onHide={toggleMore} size="lg" className="kr-modal">
        <Modal.Body>
          <div className="row">
            {insignias.map((elm, i) => {
              return (
                <div key={i} className="col-6 col-md-4 col-lg-4 p-2">
                  <div className={role === "admin" ? "admin-medal" : ""}>
                    <div
                      className={
                        "medal " + getMedalClass(elm?.typeMedalId?.typeMedalId)
                      }
                    />
                    <p>{elm.nota}</p>
                    {role === "admin" && (
                      <button
                        className="trash-medal"
                        style={{ color: "rgb(225, 29, 72)" }}
                        onClick={() => deleteMedal(elm)}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
